<div class="intro-container">
  <div class="image-container">
    <img *ngIf="imagePath" [src]="imagePath">
  </div>
  <div class="intro-content">
    <div [ngStyle]="{'background-color': lineConfig.sectionColor}" class="intro-title">
      <h2>{{config.title}}</h2>
    </div>
    <div class="intro-inner-content">
      <app-dynamic-content
        [contentId]="'intro-desc'"
        [htmlContent]="description">
      </app-dynamic-content>
      <ul class="intro-list row d-flex justify-content-center">
        <li class="col-xs-12 col-sm-6 col-md-6 col-lg-4" *ngFor="let subPackage of subPackages; let subPackageIndex = index">
          <a appAnimateArrowOnHover href="/category/{{categorySlug}}/#{{subPackage.fragment}}"
            [ngStyle]="{'color': lineConfig.sectionColor}" [attr.data-subpackage]="subPackage.fragment" target="_self"
            (click)="scrollToSection($event, subPackage.fragment)">
            <span>{{subPackage.link.title}}</span>
            <i [ngStyle]="{'color': lineConfig.sectionColor}" class="fa fab fa-long-arrow-down"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>